namespace GeniuzPOS.ReportMasterData {
    export namespace Report_1201_DiscService {
        export const baseUrl = 'ReportMasterData/Report_1201_Disc';

        export declare function Create(request: Serenity.SaveRequest<Report_1201_DiscRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<Report_1201_DiscRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<Report_1201_DiscRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<Report_1201_DiscRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ReportMasterData/Report_1201_Disc/Create",
            Update = "ReportMasterData/Report_1201_Disc/Update",
            Delete = "ReportMasterData/Report_1201_Disc/Delete",
            Retrieve = "ReportMasterData/Report_1201_Disc/Retrieve",
            List = "ReportMasterData/Report_1201_Disc/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>Report_1201_DiscService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
